import { render, staticRenderFns } from "./FPageStuck.vue?vue&type=template&id=0c072b61&"
import script from "./FPageStuck.vue?vue&type=script&lang=js&"
export * from "./FPageStuck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports